// packages
import { select } from 'd3-selection';

export function occlusion(
  selections,
  klass,
  attr = 'county',
  buffer = 4,
  mapping
) {
  const texts = [];

  selections.each((_, i, nodes) => {
    const node = nodes[i];
    const bbox = node.getBoundingClientRect();

    texts.push({
      bbox,
      node,
    });
  });

  texts.sort();

  const filled = [];

  texts.forEach((text) => {
    const isOccluded = filled.some((d) =>
      isIntersecting(text.bbox, d.bbox, buffer)
    );

    const sel = select(text.node);
    mapping.set(sel.datum()[attr], isOccluded);

    sel.classed(klass, isOccluded);

    if (!isOccluded) filled.push(text);
  });
}

function isIntersecting(r1, r2, buffer = 0) {
  return !(
    r2.left - buffer > r1.right + buffer ||
    r2.right + buffer < r1.left - buffer ||
    r2.top - buffer > r1.bottom + buffer ||
    r2.bottom + buffer < r1.top - buffer
  );
}
